export const storageKey = "giantsvillage.game";
export const walletConnectDeepLink = process.env.NEXT_PUBLIC_WALLET_CONNECT_DEEP_LINK;
export const saltKeyStart = "heygiants";
export const network = {
    mainnet: {api: "https://elrond-api.blastapi.io/48a2dc87-7afc-4047-b05f-2c340adb85f5"},
    devnet: {api: "https://devnet-api.multiversx.com"},
    testnet: {api: "https://testnet-api.multiversx.com"}
}
export const walletConnectProjectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID;